import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const NumberOfBeds: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()
  return (
    <div className={`grid-item margin-top-l ${wrapperClassName}`}>
      <TextInput
        id='number-of-beds'
        propertyName='numberOfBeds'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.numberOfBeds', 'NumberOfBeds')}</span>}
        value={insertionData.numberOfBeds}
        maxLength={6}
        type='tel'
        errors={validationMessages!.numberOfBeds ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default NumberOfBeds
